import type React from "react";
import { useLayoutEffect, useState } from "react";

const useElementRect = (containerRef: React.RefObject<HTMLElement>): DOMRect | undefined => {
  const [rect, setRect] = useState<DOMRect>();

  useLayoutEffect(() => {
    const domElement = containerRef.current;

    // Guard against null element (can happen during initial render or conditional rendering)
    if (!domElement) return undefined;

    // Method called to update the rect value on changes
    const updateRect = () => {
      if (domElement) {
        setRect(domElement.getBoundingClientRect());
      }
    };

    // First load
    updateRect();

    if (typeof window.ResizeObserver === "function") {
      // on-resize, element-wise
      const resizeObserver = new ResizeObserver(updateRect);
      resizeObserver.observe(domElement);
      return () => resizeObserver.unobserve(domElement);
    } else {
      // on-resize on non supporting browsers: we listen to the whole window
      window.addEventListener("resize", updateRect);
      return () => window.removeEventListener("resize", updateRect);
    }
  }, [containerRef, setRect]);

  return rect;
};

export default useElementRect;
